export class CrescimentoCapIncompativelMessageStrategy {
	constructor(capAnterior, capAtual) {
		this.capAnterior = capAnterior
		this.capAtual = capAtual
	}

	get short() {
		return { message: 'Crescimento do CAP é incompatível' }
	}

	get long() {
		const message =
			this.capAnterior > this.capAtual
				? `O CAP coletado atual (${this.formattedCurrentCap}cm) é menor que o coletado no inventário anterior (${this.formattedPreviousCap}cm)`
				: `O CAP coletado atual (${this.formattedCurrentCap}cm) é maior que o coletado no inventário anterior (${this.formattedPreviousCap}cm)`
		const title =
			this.capAnterior > this.capAtual
				? 'CAP atual é menor que CAP do inventário anterior'
				: 'CAP atual é maior que CAP do inventário anterior'
		return { message, title }
	}

	get formattedPreviousCap() {
		return Number(this.capAnterior).toFixed(2)
	}

	get formattedCurrentCap() {
		return Number(this.capAtual).toFixed(2)
	}
}
